import React, { Component } from "react";
import { Growl } from "primereact/growl";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";

export default class Edit extends Component {
  constructor(props) {
    super(props);

    var _date =
      typeof this.props.pData.date === "undefined" ||
        this.props.pData.date === "" ||
        this.props.pData.date === null
        ? null
        : new Date(this.props.pData.date);

    this.state = {
      _id: this.props.pData._id,
      date: _date,
      type: this.props.pData.type,
      types: [
        { label: "Doctor", value: "Doctor" },
        { label: "Emergency", value: "Emergency" },
        { label: "Nurse", value: "Nurse" },
        { label: "Volunteer", value: "Volunteer" }
      ]
    };

    this.handleDateChange = this.handleDateChange.bind(this);

  }

  render() {
    return (
      <div>
        <h5 align="center">Edit Home Care</h5>
        <div className="container-fluid">
          <div className="row p-1 border">
            <div className="col col-md-2">Date</div>
            <div className="col col-md-3">
              <DatePicker
                selected={this.state.date}
                onChange={this.handleDateChange}
                dateFormatCalendar={"MMM yyyy"}
                minDate={subMonths(new Date(), 6)}
                maxDate={addMonths(new Date(), 6)}
                showMonthYearDropdown
                dateFormat="dd-MMM-yyyy"
              />
            </div>
          </div>
          <div className="row p-1 border">
            <div className="col col-md-2">Type</div>
            <div className="col col-md-3">
              <Dropdown
                value={this.state.type}
                options={this.state.types}
                placeholder="Select Type"
                onChange={e => this.setState({ type: e.target.value })}
                style={{ width: "270px" }}
              />
            </div>
          </div>

          <div className="row p-1 border">
            <button
              onClick={this.onSaveClick}
              className="btn btn-primary btn-md mr-2"
            >
              Update
            </button>

            <button
              onClick={this.onCancelClick}
              className="btn btn-primary btn-md mr-2"
            >
              Cancel
            </button>
          </div>
          <Growl ref={el => (this.growl = el)} />
        </div>
      </div>
    );
  }

  handleDateChange(date) {
    this.setState({ date });
  }

  onSaveClick = async e => {
    e.preventDefault();

    if (this.state.date !== null) {

      const obj = {
        date: this.state.date,
        type: this.state.type
      };

      axios
        .put(
          (process.env.NODE_ENV !== "development"
            ? appConst.API_URL_PROD
            : appConst.API_URL_DEV) +
          "/patient/homeCarePlan/" + this.state._id,
          obj
        )
        .then(res => {
          this.props.onClick("List", null, this.props.pno, this.props.name);
        })
        .catch(error => {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Something went wrong !!"
          });
        });

    } else {
      this.growl.show({
        severity: "error",
        summary: "Error !!",
        detail: "Invalid Input !!"
      });
    }
  };

  onCancelClick = e => {
    this.props.onClick("List", null, this.props.pno, this.props.name);
  };
}
